import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { CourseDetailsDTO } from '../../models/CourseDTO';
import { SmallBadgeComponent } from '../../../../../shared/components/small-badge/small-badge.component';
import { CourseIconMappingService } from '../../../../../shared/services/course-icon-mapping.service';

@Component({
  selector: 'app-course-library-card',
  imports: [MatIcon, MatTooltipModule, TranslocoModule, SmallBadgeComponent],
  templateUrl: './course-library-card.component.html',
  styleUrl: './course-library-card.component.css',
})
export class CourseLibraryCardComponent {
  private readonly courseIconMappingService = inject(CourseIconMappingService);

  @Input({ required: true }) course: CourseDetailsDTO;
  @Input() isRecommended = false;
  @Output() courseCardClickEvent: EventEmitter<void> = new EventEmitter<void>();

  getCourseIcon(): string {
    return this.courseIconMappingService.getCourseIcon(
      this.course.name,
      this.course.topicAreaName,
    );
  }
}
